var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 18C13.9706 18 18 13.9706 18 9C18 4.02945 13.9706 0 9 0C4.02945 0 0 4.02945 0 9C0 13.9706 4.02945 18 9 18ZM12.7071 5.29288C13.0976 5.68341 13.0976 6.31659 12.7071 6.70709L10.4142 9L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L9 10.4142L6.70709 12.7071C6.31659 13.0976 5.68341 13.0976 5.29288 12.7071C4.90237 12.3166 4.90237 11.6834 5.29288 11.2929L7.58578 9L5.29288 6.70709C4.90237 6.31659 4.90237 5.68341 5.29288 5.29288C5.68341 4.90237 6.31659 4.90237 6.70709 5.29288L9 7.58578L11.2929 5.29288C11.6834 4.90237 12.3166 4.90237 12.7071 5.29288Z","fill":"black"}));
}

Close.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Close;

Close.default = Close;
